import { Heading, Icon, IconButton, Select, Stack, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr } from "@chakra-ui/react";

import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { HiLink } from "react-icons/hi";



export default function IntegratedPastData() {
    
    return (
        <Stack w={'full'} justify={"center"} align={"center"} spacing={6}>
            <Stack
                direction={{ base: 'column', md: 'column', lg: 'column', xl: 'row' }}
                justify={'space-between'}
                boxShadow={'base'}
                rounded={'xl'}
                w={'98%'}
                p={4}
                spacing={{ base: 6, md: 6, lg: 6, xl: 0 }}
            >
                <Stack
                    align={'flex-start'}
                    justify={'start'}
                    spacing={4}
                >
                    <Stack direction={'row'}>
                        <Icon
                            as={HiLink}
                            fontSize={'5xl'}
                            color={'primary.400'}
                        />
                        <Stack spacing={1}>
                            <Heading fontSize={'xl'}>Integrated Past Data</Heading>
                            <Text fontSize={'sm'}>Here you can see all Integrated Past Data.</Text>
                        </Stack>
                    </Stack>
                </Stack>
                {/* <Stack align={{ lg: 'flex-start', xl: 'flex-end' }} justify={'end'} spacing={4}>
                    <Stack direction={'row'}>
                        <Stack spacing={4} direction='row'>
                            <Checkbox size={'sm'} colorScheme='primary.500'>
                                Include Test
                            </Checkbox>
                            <Checkbox size={'sm'} colorScheme='primary.500'>
                                Include Admin
                            </Checkbox>
                            <Checkbox size={'sm'} colorScheme='primary.500'>
                                Include Data Entry
                            </Checkbox>
                        </Stack>
                        <Button
                            size={'sm'}
                            leftIcon={<FaDatabase />}
                            color={'white'}
                            bg={'primary.400'}
                            _hover={{ bg: 'primary.400' }}
                            _active={{ bg: 'primary.400' }}
                        >
                            Get All Data
                        </Button>
                        <Button
                            size={'sm'}
                            leftIcon={<RiFilterOffFill />}
                            color={'white'}
                            bg={'primary.400'}
                            _hover={{ bg: 'primary.400' }}
                            _active={{ bg: 'primary.400' }}
                        >
                            Clear Filter
                        </Button>
                    </Stack>
                </Stack> */}
            </Stack>

            <Stack boxShadow={'base'} rounded={'xl'} w={'98%'} p={4} spacing={4}>
                <Stack
                    w={'full'}
                    spacing={2}
                    align={'center'}
                    direction={'row'}
                    justify={'center'}
                >
                    <Select
                        w={'100%'}
                        placeholder="Organization Name"
                    >
                        <option value="option1">Inam Space Research Organization</option>
                        <option value="option2">Entry Bot</option>
                        <option value="option3">ABC Chartered Accountants</option>
                    </Select>

                    <Select
                        w={'100%'}
                        placeholder="Entity Name"
                    >
                        <option value="option1">AG Xero Business</option>
                        <option value="option2">Brilliant Business</option>
                    </Select>
                </Stack>
                <TableContainer h={'sm'} overflowY={'scroll'}>
                    <Table size='sm'>
                        <Thead position={'sticky'} top={'0%'} h={'50px'} bg={'primary.400'} alignItems={'flex-start'}>
                            <Tr>
                                <Th
                                    isNumeric
                                    color={"white"}
                                >
                                    Sr.
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Account Code
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Category
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Description
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Supplier Name
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Invoice Status
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Created By
                                </Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            <Td colSpan={7} bg={'gray.100'} textAlign={'center'}>No data available in table.</Td>
                        </Tbody>
                    </Table>
                </TableContainer>
                <Stack
                    direction={'row'}
                    justify={"space-between"}
                    align={'center'}
                >
                    <Text>Showing 5 of 10 results</Text>
                    <Stack direction={'row'} spacing={4}>
                        <Select placeholder="Select Rows Per Page">
                            <option selected>5 Per Page</option>
                            <option>10 Per Page</option>
                            <option>25 Per Page</option>
                            <option>50 Per Page</option>
                        </Select>
                        <Stack direction={'row'}>
                            <IconButton
                                aria-label="Previous"
                                icon={<FaArrowLeft />}
                                rounded={'full'}
                            />
                            <IconButton
                                aria-label="Previous"
                                icon={<FaArrowRight />}
                                rounded={'full'}
                            />
                        </Stack>
                    </Stack>
                </Stack>
            </Stack>
        </Stack >
    )
}